/**
 * @generated SignedSource<<ce5ef5fee543a4fe2ac3b5a4bdecca7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ScheduleEditFormContainer_Query$variables = {
  scheduleSlug: string;
};
export type ScheduleEditFormContainer_QueryVariables = ScheduleEditFormContainer_Query$variables;
export type ScheduleEditFormContainer_Query$data = {
  readonly schedule: {
    readonly id: string;
    readonly slug: string;
    readonly startTime: string | null;
    readonly endTime: string | null;
  };
};
export type ScheduleEditFormContainer_QueryResponse = ScheduleEditFormContainer_Query$data;
export type ScheduleEditFormContainer_Query = {
  variables: ScheduleEditFormContainer_QueryVariables;
  response: ScheduleEditFormContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scheduleSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "scheduleSlug"
      }
    ],
    "concreteType": "Schedule",
    "kind": "LinkedField",
    "name": "schedule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTime",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleEditFormContainer_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScheduleEditFormContainer_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ccc4b9621fd151abac346a563088cfdb",
    "id": null,
    "metadata": {},
    "name": "ScheduleEditFormContainer_Query",
    "operationKind": "query",
    "text": "query ScheduleEditFormContainer_Query(\n  $scheduleSlug: String!\n) {\n  schedule(slug: $scheduleSlug) {\n    id\n    slug\n    startTime\n    endTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "7529fc1765621dba1a8dc8abf057960a";

export default node;
